export default "assets/images/icons/linkedin-dfefb2cb.svg";